import React, { useState , useEffect } from "react";

import "./BookingEmailVerificationPopup.css"
import { Link , useNavigate } from "react-router-dom";

import { toast } from "react-toastify";


const EmailVerificationPopup = ({ email, onVerify, onClose }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otp2, setOtp2] = useState("");

const navigate = useNavigate()

const didFetch = React.useRef(false);

useEffect(() => {
if (didFetch.current) return;
  didFetch.current = true;

  if (!email) return;
  
  fetch("https://yovho-back.vercel.app/booking-new-code-send", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: email }),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Network response was not ok " + res.statusText);
      }
      return res.json(); // agar backend JSON bhej raha hai
    })
    .then((data) => {
      console.log("Server Response:", data);
      setOtp2(data.otp)
      // setShowPopup(true);
       // popup yahan open karo jab response mile
    })
    .catch((err) => {
      console.error("Error in fetch:", err);
    });


  }, [email]);



  const handleChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); // only numbers
    if (value.length > 1) return;

    let newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto focus next box
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };


  const handleVerify = () => {
  // 1) array (otp) سے string بنائیں — loop استعمال کر کے (آپ کی درخواست کے مطابق)
  let codeFromArray = "";
  for (let i = 0; i < otp.length; i++) {
    // otp[i] undefined ہو تو empty string لگائیں
    codeFromArray += otp[i] ? String(otp[i]) : "";
  }

  // 2) length check
  if (codeFromArray.length !== 6) {
    toast.success("Please enter the 6-digit code.");
    return;
  }

  // 3) otp2 آپ کے پاس کہیں موجود ہونا چاہیے (parent/component scope).
  //    اگر نہیں ہے تو user کو اطلاع دو۔
  if (typeof otp2 === "undefined" || otp2 === null) {
    console.error("otp2 is not defined in scope.");
    toast.success("Verification code not available. Please request a new code.");
    return;
  }

  const otp2Str = String(otp2); // ensure string

  // 4) Compare (strict string compare)
  if (otp2Str === codeFromArray) {
    console.log("successful");
      onClose(true); 
      navigate("/check-booking");


    // optional: اگر چاہیں تو یہاں پر onVerify() یا navigate() بھی کال کر سکتے ہیں:
    // onVerify && onVerify();
  } else {
    toast.success("Please enter the 6-digit code correctly");
  }
};


  
  const handleSubmit = () => {

  setOtp(["", "", "", "", "", ""])

  fetch("https://yovho-back.vercel.app/booking-new-code-send", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: email }),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Network response was not ok " + res.statusText);
      }
      return res.json(); // agar backend JSON bhej raha hai
    })
    .then((data) => {
      console.log("Server Response:", data);
           setOtp2(data.otp)
      // onClose(true); 
      // popup yahan open karo jab response mile
    })
    .catch((err) => {
      console.error("Error in fetch:", err);
    });
};


  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="close-btn" onClick={onClose}>×</button>
        <h4>Verify your email address</h4>
        <p>
          We sent a verification code to <b>{email}</b>. Enter this code to continue.
        </p>

        <div className="otp-inputs">
          {otp.map((digit, i) => (
            <input
              key={i}
              id={`otp-${i}`}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e, i)}
            />
          ))}
        </div>

        <button className="verify-btn" onClick={()=>handleVerify()}>
          Verify email
        </button>


<div className="links">
  <button 
    onClick={()=>handleSubmit()} 
    style={{ background: "none", border: "none", color: "blue", cursor: "pointer", textDecoration: "underline" }}
  >
    Request new code
  </button>
  <br />
  <button 
    onClick={() => window.location.reload()} 
    style={{ background: "none", border: "none", color: "blue", cursor: "pointer", textDecoration: "underline" }}
  >
    Not now
  </button>
</div>


        {/* <div className="links">
          <a href="#">Request new code</a>
          <br />
          <a href="#">Not now</a>
        </div> */}
        {/* <br /> */}
        <div className="links">
          <p style={{fontSize:"14px"}}>By signing in or creating an account, you agree with our <Link to="/term" style={{color:"blue"}}>Terms & Conditions</Link>  and <Link to="/privacy" style={{color:"blue"}}>Privacy Statement</Link></p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationPopup;
